import VideoModal from 'modules/common/VideoModal';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import playback from 'theme/assets/images/playback.svg';

class CommonErrorsButton extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    isModalVisible: false,
  };

  toggleCommonErrorsModal = () => {
    this.setState((state) => ({isModalVisible: !state.isModalVisible}));
  };

  render() {
    const {
      className = '',
      code_challenge_helper_youtube_id,
      color,
      intl: {formatMessage},
    } = this.props;
    const {isModalVisible} = this.state;
    if (code_challenge_helper_youtube_id)
      return (
        <div>
          <li className={className} onClick={this.toggleCommonErrorsModal}>
            <img className="ml2" src={playback} alt="review video" />
            <FormattedMessage id="common_errors" />
          </li>
          {isModalVisible && (
            <VideoModal
              rightButtonClick={this.toggleCommonErrorsModal}
              color={color}
              videoId={code_challenge_helper_youtube_id}
              title={formatMessage({id: 'common_errors'})}
            />
          )}
        </div>
      );
    return null;
  }
}

CommonErrorsButton.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  code_challenge_helper_youtube_id: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(CommonErrorsButton);
